import { useFeatureFlag } from './feature-flags';
import { PartnerApiIcon } from './icons/nav';
import { getPartnerApiManageUrl } from './lib/environment';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from './sidebar';

/**
 * The Partner API link at the foot of the modern-shell sidebars (Neo and
 * Dashboards), above the user menu. It opens the Partner API dashboard on the
 * realtime service. The Hub renders the same link with Chakra
 * (`PartnerApiLink.tsx`).
 *
 * It shows only while the partner's `partner_api` flag is on AND the person can
 * read the Partner API permission section. The caller passes that as `canRead`
 * (`useCanRead('partner_api')`), because `@artic/ui` never imports
 * `@artic/api-client`. Both only hide the link: realtime enforces the
 * permission on the dashboard itself. The label arrives translated, as
 * `@artic/ui` has no i18n.
 */
export function PartnerApiNavLink({ label, canRead }: { label: string; canRead: boolean }) {
  const enabled = useFeatureFlag('partner_api');
  if (!enabled || !canRead) return null;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild tooltip={label}>
          <a href={getPartnerApiManageUrl()}>
            <PartnerApiIcon aria-hidden />
            <span>{label}</span>
          </a>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
